import { Routes } from "@angular/router";
import { ChatPageComponent } from "@app/applications/chat/pages/chat-page/chat-page.component";
import { getSwapRequestResolver } from "@app/shared/swap-request/resolvers/get-swap-request.resolver";
import { getChatMessagesResolver } from "@app/applications/chat/resolvers/get-chat-messages.resolver";

export const chatRoutes: Routes = [
  {
    path: ":conversationId",
    component: ChatPageComponent,
    data: {
      swapRequestIdParamKey: "conversationId",
    },
    resolve: {
      swapRequest: getSwapRequestResolver,
      resolvedMessages: getChatMessagesResolver,
    },
  },
  {
    path: "",
    component: ChatPageComponent,
  },
];
